var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconWebform24 = function SvgAIconWebform24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3784 13.6202L13.7505 21.25L10 22L10.7501 18.2501L18.382 10.6203C18.7785 10.2232 19.3166 10 19.8777 10C20.4389 10 20.977 10.2232 21.3734 10.6203L21.3824 10.6283C22.2074 11.4556 22.2056 12.795 21.3784 13.6202Z",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19H3.33333C2.59695 19 2 18.4145 2 17.6923V3.30769C2 2.58547 2.59695 2 3.33333 2H16.6667C17.403 2 18 2.58547 18 3.30769V7",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.5H11",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.5H13",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgAIconWebform24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjEuMzc4NCAxMy42MjAyTDEzLjc1MDUgMjEuMjVMMTAgMjJMMTAuNzUwMSAxOC4yNTAxTDE4LjM4MiAxMC42MjAzQzE4Ljc3ODUgMTAuMjIzMiAxOS4zMTY2IDEwIDE5Ljg3NzcgMTBDMjAuNDM4OSAxMCAyMC45NzcgMTAuMjIzMiAyMS4zNzM0IDEwLjYyMDNMMjEuMzgyNCAxMC42MjgzQzIyLjIwNzQgMTEuNDU1NiAyMi4yMDU2IDEyLjc5NSAyMS4zNzg0IDEzLjYyMDJaIiBzdHJva2Utd2lkdGg9IjEuNiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8cGF0aCBkPSJNNyAxOUgzLjMzMzMzQzIuNTk2OTUgMTkgMiAxOC40MTQ1IDIgMTcuNjkyM1YzLjMwNzY5QzIgMi41ODU0NyAyLjU5Njk1IDIgMy4zMzMzMyAySDE2LjY2NjdDMTcuNDAzIDIgMTggMi41ODU0NyAxOCAzLjMwNzY5VjciIHN0cm9rZS13aWR0aD0iMS42IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik02IDYuNUgxMSIgc3Ryb2tlLXdpZHRoPSIxLjYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPHBhdGggZD0iTTYgMTAuNUgxMyIgc3Ryb2tlLXdpZHRoPSIxLjYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPC9zdmc+";